export default {
    name: 'collectionProductSearch',
    list: 'list',
    meta: 'meta',
    query: 'query',
    fetchId: 'fetchId',
    searchId: 'searchId',
    selectedProducts: 'selectedProducts',
};
